/*
  ErgoLab -- COD / bank-transfer buy box for VARIANT products: generalised copy of
  pdp-bedding-cod.js (bedding, colour + size) that also handles colour-only products
  (towel set, hair wrap): there the colour tap is the confirming tap, nothing is
  pre-ticked, and editing a folded item re-opens the tiles with nothing selected.
  Config: window.PCO_VARIANT_CONFIG (same keys as PCO_BEDDING_CONFIG plus pickLabel,
  unitWord, addLinkText).

  Keeps the theme's own colour + size picker, price, "what's included" strip and the
  "ยกระดับประสบการณ์" cross-sell cards exactly as they are, and adds on top:

    - no quantity stepper; instead a "ต้องการเพิ่มอีกชุด?" link after a size is picked.
      Tapping it folds the current set into a strip and re-opens the same picker for the
      next set (colour pre-selected like the previous set, size NOT selected; tapping a
      size confirms the set and folds it too). Strips have แก้ไข / ลบ.
    - "what's included" totals across all sets (sheets, pillowcases 1 per 3.5 ft set /
      2 per 5-6 ft set, 1 free sleeping mask per set).
    - cross-sell picks are captured at submit time into the COD order (role 'addon')
      instead of being POSTed to the real Shopify cart.
    - the pillow/seat payment block (COD / bank transfer, address form after a method is
      tapped, card link falls back to the theme's normal add-to-cart).

  Session record written to sessionStorage['pco_session_v1'] is the same shape the
  pillow funnel writes (pdp-real-cod.js) plus `bases: [...]`, one entry per distinct
  variant, which pdp-cod-pages.js (confirmation page) uses to send one base line per set.
  Config: window.PCO_BEDDING_CONFIG { reserveUrl, productTitle, upsellPath, giftVariantId,
  giftPerUnit }.
*/
(function () {
  'use strict';

  var PCO_SESSION_KEY = 'pco_session_v1';
  var DEFAULT_UPSELL_PATH = 'pages/cod-order-confirmation';
  var PAYMENT_METHOD_LABELS = { cod: 'Cash on Delivery', bank: 'Bank Transfer' };
  var FREE_MASK_VARIANT_ID = '42610235867241';
  var BANK_NOTE_TEXT = 'หลังจากสั่งซื้อ คุณจะได้รับรายละเอียดบัญชีธนาคารและลิงก์ LINE สำหรับส่งสลิปการชำระเงินทันที';

  function pcoGenToken() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'pco-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }
  function pcoSaveSession(session) {
    try { sessionStorage.setItem(PCO_SESSION_KEY, JSON.stringify(session)); } catch (e) { /* noop */ }
  }
  function formatThaiPhone(raw) {
    var digits = (raw || '').replace(/\D/g, '');
    if (digits.indexOf('66') === 0 && digits.length > 9) { digits = digits.slice(2); }
    digits = digits.replace(/^0+/, '');
    return digits ? '+66' + digits : '';
  }
  function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function formatBaht(n) {
    return '฿' + Math.round(Number(n) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function toBaht(cents) { return Math.round(Number(cents) || 0) / 100; }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }

  // 3.5 ft => 1 pillowcase, 5 ft / 6 ft => 2 (same rule as the theme's whatwillyouget()).
  function pillowcasesForSize(sizeText) {
    var m = String(sizeText || '').match(/\d+(\.\d+)?/);
    if (!m) return 2;
    return parseFloat(m[0]) >= 5 ? 2 : 1;
  }

  function buildPaymentBlockHtml() {
    return ''
      + '<div class="pco-real-payment" id="pco-real-payment">'
      + '  <div class="pco-bed-total" id="pco-bed-total" style="display:none;"><span class="pco-bed-total-label" id="pco-bed-total-label"></span><span class="pco-bed-total-value" id="pco-bed-total-value"></span></div>'
      + '  <p class="pco-real-label">เลือกวิธีการชำระเงิน</p>'
      + '  <div class="pco-real-methods">'
      + '    <button type="button" class="pco-real-method-btn" data-method="cod">เก็บเงินปลายทาง</button>'
      + '    <button type="button" class="pco-real-method-btn" data-method="bank">โอนเงินผ่านธนาคาร</button>'
      + '  </div>'
      + '  <div class="pco-real-form" id="pco-real-form" style="display:none;">'
      + '    <div class="pco-real-field"><label for="pco-real-name">ชื่อ-สกุล</label><input type="text" id="pco-real-name" placeholder="ชื่อ-สกุล" autocomplete="name"></div>'
      + '    <div class="pco-real-field"><label for="pco-real-phone">เบอร์โทร</label><div class="pco-real-phone-wrap"><span class="pco-real-phone-flag">🇹🇭 +66</span><input type="tel" id="pco-real-phone" placeholder="8X XXX XXXX" autocomplete="tel" inputmode="numeric"></div></div>'
      + '    <div class="pco-real-field"><label for="pco-real-email">อีเมล</label><input type="email" id="pco-real-email" placeholder="อีเมล" autocomplete="email"></div>'
      + '    <div class="pco-real-field"><label for="pco-real-address">ที่อยู่ (โปรดกรอกให้ครบถ้วน)</label><input type="text" id="pco-real-address" placeholder="ที่อยู่ (บ้านเลขที่ ถนน ตำบล/แขวง)" autocomplete="street-address"></div>'
      + '    <div class="pco-real-field"><label for="pco-real-zip">รหัสไปรษณีย์</label><input type="text" id="pco-real-zip" placeholder="รหัสไปรษณีย์" autocomplete="postal-code" inputmode="numeric"></div>'
      + '  </div>'
      + '  <p class="pco-real-note" id="pco-real-note" style="display:none;"></p>'
      + '  <p class="pco-real-card-link"><a href="javascript:void(0)" id="pco-real-card-link">ต้องการชำระด้วยบัตรเดบิต/เครดิต หรือช่องทางอื่น? คลิกที่นี่</a></p>'
      + '  <p class="pco-real-msg" id="pco-real-msg" hidden></p>'
      + '</div>';
  }

  function init() {
    var boxed = document.querySelector('.product-boxed-section');
    if (!boxed) return;
    var form = boxed.querySelector('form[data-type="add-to-cart-form"]') || boxed.querySelector('form');
    if (!form) return;
    var submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    if (!submitBtn) return;
    if (!boxed.querySelector('variant-selects')) return; // variant picker is the whole point

    var config = window.PCO_VARIANT_CONFIG || window.PCO_BEDDING_CONFIG || {};
    // Colour-only products (towel set, hair wrap): the colour tap is the confirming tap.
    // Two-option products (bedding): colour + size, the size tap confirms.
    var hasSize = !!(function () { var p = boxed.querySelector('variant-selects'); return p && p.querySelectorAll('fieldset').length > 1; })();
    var confirmOption = hasSize ? 'size' : 'color';
    var pickLabel = config.pickLabel || (hasSize ? 'เลือกขนาด' : 'เลือกสี');
    var unitWord = config.unitWord || 'ชุด';
    var reserveUrl = config.reserveUrl || '';
    var upsellPath = config.upsellPath || DEFAULT_UPSELL_PATH;
    var giftVariantId = String(config.giftVariantId || FREE_MASK_VARIANT_ID);
    var giftPerUnit = (config.giftPerUnit === 0 || config.giftPerUnit) ? Number(config.giftPerUnit) : 1;
    var productTitle = config.productTitle || '';
    var themeDefaultLabel = 'หยิบใส่ตะกร้า';

    boxed.classList.add('pco-bed');

    /* ------------------------------------------------------------------ picker access
       product-info.js swaps the whole <variant-selects> element on every option change
       (inserts the new one BEFORE the old one, removes the old after 500ms), so never keep
       a reference: always look it up, and keep it inside our own wrapper so hiding the
       wrapper hides whichever node is current. */
    var pickerWrap = document.createElement('div');
    pickerWrap.className = 'pco-bed-picker-wrap';
    var firstPicker = boxed.querySelector('variant-selects');
    firstPicker.parentNode.insertBefore(pickerWrap, firstPicker);
    pickerWrap.appendChild(firstPicker);

    function picker() { return pickerWrap.querySelector('variant-selects'); }
    function pickerFieldsets() {
      var p = picker();
      if (!p) return { color: null, size: null };
      var sets = Array.prototype.slice.call(p.querySelectorAll('fieldset'));
      var size = null, color = null;
      sets.forEach(function (fs) {
        var t = (fs.querySelector('.titleofvariant') || fs.querySelector('legend') || { textContent: '' }).textContent;
        if (/ขนาด/.test(t) || fs.querySelector('.custom-check-variant')) size = size || fs;
        else color = color || fs;
      });
      if (!size && sets.length > 1) size = sets[sets.length - 1];
      if (!color && sets.length) color = sets[0];
      if (!hasSize) { color = sets[0] || null; size = null; }
      return { color: color, size: size };
    }
    function checkedIn(fs) { return fs ? fs.querySelector('input[type="radio"]:checked') : null; }
    function selectedVariantJson() {
      var p = picker();
      var s = p && p.querySelector('[data-selected-variant]');
      if (!s) return null;
      try { return JSON.parse(s.textContent); } catch (e) { return null; }
    }
    // Un-picks the confirming option (size, or the colour on colour-only products).
    function unselectSize() {
      var fsets = pickerFieldsets();
      var fs = hasSize ? fsets.size : fsets.color;
      if (!fs) return;
      Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) { r.checked = false; });
      Array.prototype.forEach.call(fs.querySelectorAll('.swatch-card'), function (c) { c.classList.remove('active-card'); });
      if (!hasSize) { var lbl = fs.querySelector('.titleofvariant span'); if (lbl) lbl.style.display = 'none'; }
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = '';
    }
    function currentSelection() {
      // The live picker's choice, only when BOTH colour and size are picked.
      var fs = pickerFieldsets();
      var c = checkedIn(fs.color), s = checkedIn(fs.size);
      if (!c || (hasSize && !s)) return null;
      var v = selectedVariantJson();
      if (!v || !v.id) return null;
      var colorText = c.value, sizeText = s ? s.value : '';
      var img = (v.featured_image && v.featured_image.src) || config.productImage || '';
      return {
        variantId: String(v.id),
        color: colorText,
        size: sizeText,
        title: (v.title || (sizeText ? colorText + ' / ' + sizeText : colorText)),
        price: toBaht(v.price),
        compare: toBaht(v.compare_at_price),
        image: img,
        available: v.available !== false
      };
    }

    /* ------------------------------------------------------------------ state
       mode 'set1'   : no strips; the live picker IS set 1
       mode 'adding' : >=1 strip; picker open for the next set (size not picked yet)
       mode 'strips' : >=1 strip; picker hidden */
    var sets = [];
    var mode = 'set1';
    var lastClickedOption = null; // 'color' | 'size'
    // After 'another set' / 'edit', the size must be picked explicitly: the theme's picker
    // re-render auto-checks the first size whenever only the colour changes.
    // True until the customer taps a size themselves: the theme's picker re-render auto-checks
    // the first size after a colour tap, and Luka wants "เลือกขนาด" to stay until a real size tap.
    var keepSizeUnpicked = true;

    var stripsEl = el('<div class="pco-bed-sets" id="pco-bed-sets" style="display:none;"><p class="pco-bed-sets-title" id="pco-bed-sets-title"></p><div class="pco-bed-strips" id="pco-bed-strips"></div></div>');
    boxed.insertBefore(stripsEl, pickerWrap);
    var stripsList = stripsEl.querySelector('#pco-bed-strips');
    var stripsTitle = stripsEl.querySelector('#pco-bed-sets-title');

    var addingHead = el('<div class="pco-bed-adding-head" id="pco-bed-adding-head" style="display:none;"><span class="pco-bed-adding-label" id="pco-bed-adding-label"></span><span class="pco-bed-adding-line"></span><a href="javascript:void(0)" class="pco-bed-adding-cancel" id="pco-bed-adding-cancel">ยกเลิก</a></div>');
    boxed.insertBefore(addingHead, pickerWrap);

    // "Want to add another set?" link: after the qty/price/what's-included block,
    // before the cross-sell section.
    var qtySection = boxed.querySelector('.product-qty-section');
    var addLink = el('<a href="javascript:void(0)" class="pco-bed-add-link" id="pco-bed-add-link" style="display:none;"><span class="pco-bed-add-plus">+</span><span class="pco-bed-add-text"></span></a>');
    addLink.querySelector('.pco-bed-add-text').textContent = config.addLinkText || ('เพิ่มอีก' + (config.unitWord || 'ชุด') + 'ไหม?');
    if (qtySection && qtySection.parentNode === boxed) boxed.insertBefore(addLink, qtySection.nextSibling);
    else boxed.insertBefore(addLink, pickerWrap.nextSibling);

    // Payment block: right before the theme's buy-button block (form + shipping text + card logos).
    var host = form;
    while (host.parentElement && host.parentElement !== boxed) host = host.parentElement;
    // "คนอื่นกำลังสั่งสินค้า" social-proof line stays glued to the button: payment block goes above it.
    var viewing = boxed.querySelector('.viewing_txt');
    if (viewing && viewing.parentNode === boxed && viewing.compareDocumentPosition(host) & Node.DOCUMENT_POSITION_FOLLOWING) host = viewing;
    var block = el(buildPaymentBlockHtml());
    boxed.insertBefore(block, host);

    /* ------------------------------------------------------------------ "คุณประหยัด" badge
       The v2 (bedding) template renders one server-side; this template's price row has none,
       so draw it next to the before/after price and keep it in sync with the picked variant. */
    var saveCol = null;
    function renderSaveBadge() {
      var priceEl = boxed.querySelector('.product-qty-section price-per-item');
      if (!priceEl || !priceEl.parentNode) return;
      if (!saveCol || !saveCol.parentNode) saveCol = boxed.querySelector('.product-qty-section [data-save-col]'); // v2 templates render one server-side
      if (!saveCol || !saveCol.parentNode) {
        saveCol = el('<div class="save-col pco-save-col" data-save-col>คุณประหยัด <br class="hide-mob"><span data-save-value></span></div>');
        priceEl.parentNode.insertBefore(saveCol, priceEl.nextSibling);
      }
      var v = selectedVariantJson();
      var cmp = v ? toBaht(v.compare_at_price) : 0, pr = v ? toBaht(v.price) : 0;
      if (!v) {
        var dd = priceEl.querySelector('[data-compare]'), dp = priceEl.querySelector('[data-price]');
        cmp = dd ? toBaht(dd.getAttribute('data-compare')) : 0; pr = dp ? toBaht(dp.getAttribute('data-price')) : 0;
      }
      var save = cmp - pr;
      saveCol.querySelector('[data-save-value]').textContent = formatBaht(save);
      saveCol.style.display = save > 0 ? '' : 'none';
    }
    renderSaveBadge();

    /* ------------------------------------------------------------------ button */
    submitBtn.classList.add('pco-cta-btn');
    // The v2 template already draws a cart icon on the button's span (span::after), so
    // no extra icon here. The theme's .loading__spinner must stay inside the button:
    // product-form.js (native add-to-cart for the card/other-payment path) needs it.
    var labelSpan = document.createElement('span');
    labelSpan.className = 'pco-cta-label';
    function mountButtonContents() {
      Array.prototype.slice.call(submitBtn.childNodes).forEach(function (n) {
        if (n === labelSpan) return;
        if (n.nodeType === 3) { submitBtn.removeChild(n); return; }
        if (n.nodeType === 1 && n.tagName === 'SPAN' && !n.classList.contains('loading__spinner') && !n.querySelector('.loading__spinner')) n.style.display = 'none';
      });
      if (labelSpan.parentNode !== submitBtn) submitBtn.insertBefore(labelSpan, submitBtn.firstChild);
    }

    var methodBtns = Array.prototype.slice.call(block.querySelectorAll('.pco-real-method-btn'));
    var cardLink = block.querySelector('#pco-real-card-link');
    var innerForm = block.querySelector('#pco-real-form');
    var msgEl = block.querySelector('#pco-real-msg');
    var noteEl = block.querySelector('#pco-real-note');
    var totalRow = block.querySelector('#pco-bed-total');
    var totalLabel = block.querySelector('#pco-bed-total-label');
    var totalValue = block.querySelector('#pco-bed-total-value');
    var chosen = null;

    function requiredFields() {
      return [block.querySelector('#pco-real-name'), block.querySelector('#pco-real-phone'), block.querySelector('#pco-real-address'), block.querySelector('#pco-real-zip')];
    }
    function isCustomMethod() { return chosen === 'cod' || chosen === 'bank'; }
    function fieldsValid() { return requiredFields().every(function (f) { return f && f.value.trim().length > 0; }); }

    // Everything that will be ordered: confirmed strips + (in set1 mode) the live picker.
    function orderedSets() {
      if (mode === 'set1') { var cur = currentSelection(); return cur ? [cur] : []; }
      return sets.slice();
    }

    var wantedLabel = '', wantedDisabled = true, applying = false;
    function applyButton() {
      applying = true;
      var liveBtn = form.querySelector('button[type="submit"], button[name="add"]');
      if (liveBtn && liveBtn !== submitBtn) { submitBtn = liveBtn; submitBtn.classList.add('pco-cta-btn'); observeButton(); }
      mountButtonContents();
      if (labelSpan.textContent !== wantedLabel) labelSpan.textContent = wantedLabel;
      submitBtn.classList.toggle('pco-real-disabled', wantedDisabled);
      if (chosen === 'card') {
        // native add-to-cart path: let the theme decide disabled (size chosen or not)
        if (submitBtn.disabled !== wantedDisabled) submitBtn.disabled = wantedDisabled;
      } else if (submitBtn.disabled) {
        submitBtn.disabled = false; // we gate via pco-real-disabled + our own submit handler
      }
      applying = false;
    }
    function render() {
      var n = orderedSets().length;
      if (n === 0) {
        wantedLabel = pickLabel;
        wantedDisabled = true;
      } else if (!chosen) {
        wantedLabel = 'เลือกวิธีการชำระเงิน';
        wantedDisabled = true;
      } else if (chosen === 'card') {
        wantedLabel = themeDefaultLabel;
        wantedDisabled = false;
      } else {
        wantedLabel = 'ยืนยันการสั่งซื้อ';
        wantedDisabled = !fieldsValid();
      }
      applyButton();
      renderTotal();
    }
    var btnObserver = null;
    function observeButton() {
      if (!window.MutationObserver) return;
      if (btnObserver) btnObserver.disconnect();
      btnObserver = new MutationObserver(function () {
        if (applying) return;
        if (labelSpan.parentNode !== submitBtn || labelSpan.textContent !== wantedLabel
          || submitBtn.classList.contains('pco-real-disabled') !== wantedDisabled
          || (chosen !== 'card' && submitBtn.disabled)) {
          applyButton();
        }
      });
      btnObserver.observe(submitBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    }
    observeButton();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (applying) return;
        var liveBtn = form.querySelector('button[type="submit"], button[name="add"]');
        if (liveBtn && liveBtn !== submitBtn) applyButton();
      }).observe(form, { childList: true, subtree: true });
    }

    methodBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        methodBtns.forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        chosen = b.getAttribute('data-method');
        if (innerForm) innerForm.style.display = '';
        if (noteEl) { noteEl.textContent = chosen === 'bank' ? BANK_NOTE_TEXT : ''; noteEl.style.display = chosen === 'bank' ? '' : 'none'; }
        render();
      });
    });
    if (cardLink) {
      cardLink.addEventListener('click', function () {
        methodBtns.forEach(function (x) { x.classList.remove('sel'); });
        chosen = 'card';
        if (innerForm) innerForm.style.display = 'none';
        if (noteEl) { noteEl.textContent = ''; noteEl.style.display = 'none'; }
        render();
      });
    }
    requiredFields().forEach(function (f) { if (f) f.addEventListener('input', render); });

    /* ------------------------------------------------------------------ cross-sells
       Same read the theme's product-form.js handleCustomproducts() does at submit time
       (variant ids JSON in .variant-id-input, quantity = groups or data-quantity), but
       captured for the COD order instead of POSTed to /cart/add.js. */
    function cardSale(card, v) {
      var catalog = v ? toBaht(v.price) : 0;
      var sale = Number(card.getAttribute('data-compare') || 0) / 100;
      return (sale > 0 && sale < catalog) ? sale : catalog;
    }
    function cardFull(card, v) {
      var catalog = v ? toBaht(v.price) : 0;
      var cmp = v ? toBaht(v.compare_at_price) : 0;
      var main = Number(card.getAttribute('data-main-price') || 0) / 100;
      return Math.max(catalog, cmp, main);
    }
    function selectedCrossSells() {
      var out = [];
      Array.prototype.forEach.call(document.querySelectorAll('.custom-product-card'), function (card) {
        var input = card.querySelector('.variant-id-input');
        if (!input) return;
        var raw = (input.value || '').trim();
        if (!raw) return;
        var variants = [];
        try { variants = JSON.parse(card.querySelector('.product-variant-data').textContent) || []; } catch (e) { variants = []; }
        var cardTitle = (card.querySelector('.product-card__title') || { textContent: '' }).textContent.trim();
        var cardImg = card.querySelector('.product-card__image img');
        var ids = [];
        try { var parsed = JSON.parse(raw); if (Array.isArray(parsed)) ids = parsed.map(String); else if (parsed) ids = [String(parsed)]; }
        catch (e) { ids = [raw.replace(/^\[|\]$/g, '').trim()]; }
        ids = ids.filter(Boolean);
        if (!ids.length) return;
        var qtyMap = {};
        var singleQty = (typeof card.dataset.quantity !== 'undefined') ? (parseInt(card.dataset.quantity, 10) || 1) : 1;
        ids.forEach(function (id) { qtyMap[id] = (qtyMap[id] || 0) + 1; });
        Object.keys(qtyMap).forEach(function (id) {
          var v = null;
          for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) { v = variants[i]; break; } }
          var qty = ids.length === 1 && singleQty > 1 ? singleQty : qtyMap[id];
          var vt = v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '';
          out.push({
            variantId: id,
            qty: qty,
            productTitle: cardTitle + vt,
            image: (v && v.featured_image && v.featured_image.src) || (cardImg && cardImg.src) || card.dataset.productImage || '',
            // The card shows the cross-sell at its discounted price (data-compare, cents) under the
            // full price (data-main-price); the Worker charges the same via the Storefront cart's
            // automatic discount, so the running total here must use the discounted one too.
            price: cardSale(card, v),
            compare: cardFull(card, v)
          });
        });
      });
      return out;
    }

    // Cross-sell picks change the running total.
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.custom-product-card')) setTimeout(renderTotal, 60);
    });

    /* ------------------------------------------------------------------ strips + totals */
    function stripHtml(s, i) {
      return '<div class="pco-bed-strip" data-index="' + i + '">'
        + (s.image ? '<img class="pco-bed-strip-img" src="' + escapeHtml(s.image) + '" alt="">' : '')
        + '<span class="pco-bed-strip-info">'
        + '<span class="pco-bed-strip-title">' + escapeHtml(s.size ? s.color + ' · ' + s.size : s.color) + '</span>'
        + '<span class="pco-bed-strip-sub">' + (s.compare > s.price ? '<s>' + formatBaht(s.compare) + '</s> ' : '') + '<b>' + formatBaht(s.price) + '</b>' + (giftPerUnit > 0 ? ' · แถมฟรี! ผ้าปิดตานอน' : '') + '</span>'
        + '</span>'
        + '<a href="javascript:void(0)" class="pco-bed-strip-edit" data-index="' + i + '">แก้ไข</a>'
        + '<button type="button" class="pco-bed-strip-remove" data-index="' + i + '" aria-label="ลบ">&times;</button>'
        + '</div>';
    }
    function renderStrips() {
      if (!sets.length) { stripsEl.style.display = 'none'; stripsList.innerHTML = ''; return; }
      stripsEl.style.display = '';
      stripsTitle.textContent = 'รายการของคุณ (' + sets.length + ')';
      stripsList.innerHTML = sets.map(stripHtml).join('');
    }
    stripsList.addEventListener('click', function (e) {
      var edit = e.target.closest('.pco-bed-strip-edit');
      var rm = e.target.closest('.pco-bed-strip-remove');
      if (edit) { editSet(parseInt(edit.getAttribute('data-index'), 10)); }
      else if (rm) { removeSet(parseInt(rm.getAttribute('data-index'), 10)); }
    });

    function updateIncluded() {
      var list = orderedSets();
      var cols = boxed.querySelectorAll('.customize_box-row .included_col');
      if (!cols.length) return;
      var n = list.length;
      if (n === 0) return; // leave the theme's default text alone until a size is picked
      // Colour-only products (towel set): config.includedItems = [{pre, post, per}, ...], one per
      // "what's included" tile, text becomes pre + (n * per) + post. Without it, bedding wording only.
      if (Array.isArray(config.includedItems)) {
        config.includedItems.forEach(function (it, i) {
          var p = cols[i] && cols[i].querySelector('p');
          if (p && it) p.textContent = (it.pre || '') + (n * (it.per || 1)) + (it.post || '');
        });
        return;
      }
      if (!hasSize) return;
      var pillowcases = 0;
      list.forEach(function (s) { pillowcases += pillowcasesForSize(s.size); });
      var p0 = cols[0] && cols[0].querySelector('p');
      var p1 = cols[1] && cols[1].querySelector('p');
      var p2 = cols[2] && cols[2].querySelector('p');
      if (p0) p0.textContent = 'ผ้าปูที่นอนแบบรัดมุม ' + n + ' ผืน';
      if (p1) p1.textContent = 'ปลอกหมอน ' + pillowcases + ' ใบ';
      if (p2) p2.textContent = n > 1 ? 'ผ้าปิดตานอน ' + (n * giftPerUnit) + ' ชิ้น' : 'หน้ากากตา';
    }
    function renderTotal() {
      var list = orderedSets();
      // Only worth showing once there are 2+ sets (a single set's price is already on the page).
      if (list.length < 2) { totalRow.style.display = 'none'; return; }
      var total = 0, compare = 0, count = 0;
      list.forEach(function (s) { total += Number(s.price) || 0; compare += Number(s.compare > s.price ? s.compare : s.price) || 0; count += 1; });
      selectedCrossSells().forEach(function (a) {
        var q = a.qty || 1, pr = Number(a.price) || 0, cp = Number(a.compare) || 0;
        total += pr * q; compare += (cp > pr ? cp : pr) * q; count += q;
      });
      totalRow.style.display = '';
      totalLabel.textContent = 'รวม ' + count + ' รายการ';
      totalValue.innerHTML = (compare > total ? '<s>' + formatBaht(compare) + '</s> ' : '') + '<b>' + formatBaht(total) + '</b>';
    }

    function setMode(m) {
      mode = m;
      boxed.classList.remove('pco-bed-mode-set1', 'pco-bed-mode-adding', 'pco-bed-mode-strips');
      boxed.classList.add('pco-bed-mode-' + m);
      pickerWrap.style.display = (m === 'strips') ? 'none' : '';
      addingHead.style.display = (m === 'adding') ? '' : 'none';
      if (m === 'adding') addingHead.querySelector('#pco-bed-adding-label').textContent = unitWord + 'ที่ ' + (sets.length + 1);
      var hasOrder = orderedSets().length > 0;
      addLink.style.display = (m === 'strips' || (m === 'set1' && hasOrder)) ? '' : 'none';
      block.style.display = hasOrder ? '' : 'none';
      if (hasOrder) revealCrossSells();
      renderStrips();
      updateIncluded();
      render();
    }
    function revealCrossSells() {
      var cs = boxed.querySelector('.product-complementary-section');
      if (cs && getComputedStyle(cs).display === 'none') cs.style.display = '';
    }

    // "ต้องการเพิ่มอีกชุด?" -> fold the live set (set1 mode) or just open the picker (strips mode)
    function startAdding() {
      if (mode === 'set1') {
        var cur = currentSelection();
        if (!cur) return;
        sets.push(cur);
      }
      keepSizeUnpicked = true;
      unselectSize();
      setMode('adding');
      var head = addingHead;
      try { head.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* noop */ }
    }
    addLink.addEventListener('click', startAdding);
    addingHead.querySelector('#pco-bed-adding-cancel').addEventListener('click', function () {
      if (sets.length) setMode('strips'); else setMode('set1');
    });
    function confirmFromPicker() {
      var cur = currentSelection();
      if (!cur) return;
      sets.push(cur);
      setMode('strips');
      try { stripsEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* noop */ }
    }
    function editSet(i) {
      var s = sets[i];
      if (!s) return;
      sets.splice(i, 1);
      // Re-open the picker with that set's colour; the size is picked again to confirm.
      keepSizeUnpicked = true;
      unselectSize();
      setMode(sets.length ? 'adding' : 'set1');
      if (hasSize) selectColour(s.color); // colour-only: they pick the colour again, nothing pre-ticked
    }
    function removeSet(i) {
      sets.splice(i, 1);
      if (mode === 'strips' && !sets.length) { keepSizeUnpicked = true; unselectSize(); setMode('set1'); }
      else setMode(mode === 'adding' ? 'adding' : 'strips');
    }
    function selectColour(colorText) {
      var fs = pickerFieldsets().color;
      if (!fs) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === colorText && !radios[i].checked) {
          lastClickedOption = 'color';
          radios[i].click();
          return;
        }
      }
    }

    /* ------------------------------------------------------------------ picker events */
    // Which option the customer touched last (the theme re-renders the picker afterwards).
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !pickerWrap.contains(t)) return;
      var fs = t.closest('fieldset');
      if (!fs) return;
      lastClickedOption = (hasSize && fs === pickerFieldsets().size) ? 'size' : 'color';
    }, true);

    // product-info.js: after the section re-render it sets input[name=id] and fires 'change'.
    var settleTimer = null;
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.name !== 'id' || !form.contains(e.target)) return;
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(onPickerSettled, 0);
    });
    function onPickerSettled() {
      if (lastClickedOption === confirmOption) keepSizeUnpicked = false;
      if (mode === 'adding') {
        if (lastClickedOption === confirmOption && currentSelection()) { confirmFromPicker(); return; }
        // colour changed while choosing the next set: keep the size unpicked
        unselectSize();
        render();
        return;
      }
      if (mode === 'set1') {
        if (keepSizeUnpicked && lastClickedOption !== confirmOption) unselectSize();
        setMode('set1');
      }
      renderSaveBadge();
    }
    // The theme's own whatwillyouget() (re-run on every picker swap) rewrites the
    // pillowcase count for the live picker only; keep our totals on top of it.
    if (window.MutationObserver) {
      new MutationObserver(function () { setTimeout(updateIncluded, 0); setTimeout(renderSaveBadge, 0); }).observe(pickerWrap, { childList: true });
      var qtySec = boxed.querySelector('.product-qty-section');
      if (qtySec) new MutationObserver(function () { setTimeout(renderSaveBadge, 0); }).observe(qtySec, { childList: true, subtree: true });
    }

    /* ------------------------------------------------------------------ submit */
    function buildBases() {
      var byId = {}, order = [];
      orderedSets().forEach(function (s) {
        if (!byId[s.variantId]) {
          byId[s.variantId] = { variantId: s.variantId, quantity: 0, productTitle: productTitle + ' - ' + (s.size ? s.color + ' / ' + s.size : s.color), image: s.image, price: s.price, comparePrice: s.compare };
          order.push(s.variantId);
        }
        byId[s.variantId].quantity += 1;
      });
      return order.map(function (id) { return byId[id]; });
    }
    function reserveOrder(session, attrs) {
      if (!reserveUrl) return;
      try {
        var lines = [];
        (session.bases || []).forEach(function (b) { lines.push({ variantId: b.variantId, quantity: b.quantity, role: 'base' }); });
        (session.addons || []).forEach(function (a) { lines.push({ variantId: a.variantId, quantity: a.qty, role: 'addon' }); });
        var units = 0; (session.bases || []).forEach(function (b) { units += b.quantity; });
        var giftQty = units * giftPerUnit;
        if (giftQty > 0) lines.push({ variantId: giftVariantId, quantity: giftQty, role: 'gift' });
        fetch(reserveUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
          body: JSON.stringify({ cartToken: session.token, lineItems: lines, customer: session.customer, cartAttributes: attrs })
        }).catch(function () { /* best-effort */ });
      } catch (e) { /* noop */ }
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (chosen === 'card' && mode !== 'set1') {
        // Card / other payment with folded sets: the theme's form only knows the live
        // picker's variant, so add every set (+ cross-sells) to the real cart ourselves.
        e.preventDefault();
        e.stopImmediatePropagation();
        var items = [];
        buildBases().forEach(function (b) { items.push({ id: parseInt(b.variantId, 10), quantity: b.quantity }); });
        selectedCrossSells().forEach(function (a) { items.push({ id: parseInt(a.variantId, 10), quantity: a.qty || 1 }); });
        if (!items.length) return;
        submitBtn.classList.add('pco-real-disabled');
        fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function () {
            submitBtn.classList.remove('pco-real-disabled');
            // UpCart (the cart slider app) intercepts /cart/add.js and opens itself; nudge it
            // in case it didn't, and never redirect to /cart (the original page doesn't).
            try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) { /* noop */ }
            try { if (typeof window.upcartOpenCart === 'function') setTimeout(window.upcartOpenCart, 300); } catch (e) { /* noop */ }
          })
          .catch(function () { submitBtn.classList.remove('pco-real-disabled'); });
        return;
      }
      if (!isCustomMethod()) return; // card / no selection in set1 mode: native add-to-cart
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!fieldsValid()) return;
      var bases = buildBases();
      if (!bases.length) return;

      var paymentMethod = PAYMENT_METHOD_LABELS[chosen] || PAYMENT_METHOD_LABELS.cod;
      var name = block.querySelector('#pco-real-name').value.trim();
      var phone = formatThaiPhone(block.querySelector('#pco-real-phone').value.trim());
      var email = block.querySelector('#pco-real-email').value.trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) email = '';
      var address = block.querySelector('#pco-real-address').value.trim();
      var zip = block.querySelector('#pco-real-zip').value.trim();

      submitBtn.classList.add('pco-real-disabled');

      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return {}; })
        .then(function (cart) {
          var session = {
            token: pcoGenToken(),
            variantId: bases[0].variantId,
            quantity: bases[0].quantity,
            productTitle: bases[0].productTitle,
            price: bases[0].price,
            comparePrice: bases[0].comparePrice,
            image: bases[0].image,
            bases: bases,
            paymentMethod: paymentMethod,
            customer: { fullName: name, phone: phone, email: email, address: address, zip: zip },
            cartAttributes: (cart && cart.attributes) || {},
            addons: selectedCrossSells(),
            gift: { variantId: giftVariantId, perUnit: giftPerUnit },
            reserveUrl: reserveUrl,
            upsell: null
          };
          // Upsell-page split test (4 Oct 2026): stamp the arm on the order as custom
          // attribute upsell_variant (same as pdp-real-cod.js / pdp-bedding-cod.js).
          session.upsellVariant = (Math.random() < 0.5) ? 'A' : 'B';
          session.cartAttributes.upsell_variant = session.upsellVariant;
          // Bank-transfer upsell test (5 Oct 2026): bank customers who see the upsell mostly do not
          // pay, so 50% of bank orders skip the upsell pages and go straight to the confirmation
          // page. Stamped on the order as custom attribute bank_upsell = skip | show.
          session.bankUpsell = '';
          // 9 Oct 2026 21:2x: COD upsell switched back ON (Thailand Post data 5-7 Oct: upsell takers
          // refuse more but collect ~20% more per order). Bank transfer still always skips the upsell.
          if (chosen === 'bank') {
            session.bankUpsell = 'skip'; // 6 Oct 2026: test ended, bank transfer always skips the upsell (?bu=show still previews it)
            var buForce = (window.location.search.match(/[?&]bu=(skip|show)\b/) || [])[1]; // preview/testing switch
            if (buForce) session.bankUpsell = buForce;
            session.cartAttributes.bank_upsell = session.bankUpsell;
            if (session.bankUpsell === 'skip') { session.upsellVariant = ''; delete session.cartAttributes.upsell_variant; }
          }
          pcoSaveSession(session);
          var reserveAttrs = {};
          Object.keys(session.cartAttributes).forEach(function (k) { reserveAttrs[k] = session.cartAttributes[k]; });
          reserveAttrs['Payment Method'] = paymentMethod;
          reserveAttrs['Full Name'] = name;
          reserveAttrs['Phone'] = phone;
          reserveAttrs['Email'] = email;
          reserveAttrs['Full Address'] = address;
          reserveAttrs['Zip Code'] = zip;
          reserveOrder(session, reserveAttrs);
          window.location.href = root() + (session.bankUpsell === 'skip' ? 'pages/cod-order-confirmation' : upsellPath);
        })
        .catch(function (err) {
          submitBtn.classList.remove('pco-real-disabled');
          if (msgEl) { msgEl.textContent = (err && err.message) || 'Something went wrong'; msgEl.hidden = false; }
        });
    }, true);

    // The theme hides the cross-sell section until a swatch is clicked, and un-checks the
    // size on load (unless ?variant= is in the URL). Start from whatever state that leaves.
    setTimeout(function () {
      // ?variant= in the URL: the theme keeps that size checked, so treat it as chosen.
      var fs0 = pickerFieldsets();
      if (checkedIn(hasSize ? fs0.size : fs0.color)) keepSizeUnpicked = false;
      setMode('set1');
    }, 250);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
